<template>
  <v-navigation-drawer>
    <v-list>
      <v-list-item class="menu-item" v-for="(menu, index) in menus" :key="index">
        <button class="menu-button" @click="handleMenuSelection(menu.menuItem, menu.link)">
          {{ menu.menuItem }}
          <v-menu activator="parent" location="end" :close-on-content-click="true">
            <v-list>
              <v-list-item v-for="(submenu, index) in menu.submenus" :key="index" class="menu-item">
                <button class="menu-button" @click="handleMenuSelection(menu.menuItem, 'page', submenu)">
                  {{ submenu.subMenuItem }}
                </button>
              </v-list-item>
            </v-list>
          </v-menu>
        </button>
      </v-list-item>
    </v-list>

  </v-navigation-drawer>
</template>

<script>
import axios from 'axios';

export default {
  name: 'MainMenu',
  data() {
    return {
      menus: [],
      menuFunctions: { 'log out': () => this.logout() },
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        const response = await axios.get('/api/menu/menus-for-role?role=patient');
        this.menus = response.data;
      } catch (error) {
        console.log(error);
      }

    },
    handleMenuSelection(menuItem, menuLink, submenu) {

      if (Object.hasOwn(this.menuFunctions, menuItem.toLowerCase())) {
        this.menuFunctions[menuItem.toLowerCase()]();
        return; 
      }

      if (menuLink == '#') {
        alert("No where to go.")
      } else if (menuLink === 'page') {
        let pgid = '#';
        if (submenu.pages.length > 0) {
          console.log("HERE");
          pgid = submenu.pages[0].pageId;
        } else {
          console.log("UNDEFINED");
        }
        this.$router.push({ name: "Page", params: { pageid: pgid } });
      } else if (menuLink != null) {
        this.$router.push({ name: menuLink });
      }
    },
    goToLocation(menuLink) {
      if (menuLink != null) {
        this.$router.push({ name: menuLink });
      }
    },
    async logout() {
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        const response = await axios.post("/api/auth/logout", null, {
          withCredentials: true,
        });
        if (response.status === 200) {
          localStorage.clear();  // Clear all local storage in the domain
          this.$router.push({ name: "LoginPage" });
        } else {
          console.error(`Logout failed: ${response.statusText}`);
        }
      } catch (error) {
        console.error("Logout error:", error);
      }
    },
  }
}
</script>

<style>
.menu-item {
  width: 100%;
}

.menu-item:hover {
  background-color: #08b6aa43;
  transition: background-color 0.3s ease;
}

.menu-button {
  width: 100%;
  height: 100%;
  padding: 2%;
  text-align: left;
  text-emphasis: bold;
}
</style>